<template>
  <transition name="banner-slide">
    <div v-if="visible" class="banner-dialog" :class="type">
      <slot>{{ message }}</slot>
      <button
        v-if="dismissible"
        class="banner-dialog__close"
        type="button"
        aria-label="Close"
        @click="close"
      >
        &times;
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BannerDialog',
  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
      validator: value => ['info', 'success', 'warning', 'error'].includes(value),
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
    modelValue: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue', 'close'],
  data() {
    return {
      visible: this.modelValue,
    };
  },
  watch: {
    modelValue(val) {
      this.visible = val;
    },
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('update:modelValue', false);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.banner-dialog {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 2.5rem 0.75rem 1rem;
  font-size: 0.95rem;
  z-index: 1000;
}

.banner-dialog__message {
  text-align: center;
}

.banner-dialog__close {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.banner-dialog__close:hover {
  opacity: 1;
}

.banner-dialog.info {
  background-color: #e7f1ff;
  color: #084298;
}

.banner-dialog.success {
  background-color: #d1e7dd;
  color: #0f5132;
}

.banner-dialog.warning {
  background-color: #fff3cd;
  color: #664d03;
}

.banner-dialog.error {
  background-color: #f8d7da;
  color: #842029;
}

.banner-slide-enter-active,
.banner-slide-leave-active {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.banner-slide-enter-from,
.banner-slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
